module.exports = __webpack_public_path__ + "img/contacts_phone.d5ca30ba.svg";